import React, { useEffect, useRef, useState } from 'react';
import Card from './Card';
import FloatingActionButton from './FloatingActionButton';
import DotMenu from './DotMenu';
import { TableItem } from '..';

interface CardListProps {
  data: TableItem[];
  fetchMoreData: () => void;
  CustomerCard: boolean
  expenseCard: boolean | undefined;
  invoiceCard: boolean | undefined;
  payHistoryCard: boolean | undefined;
  inventoryCard: boolean | undefined;
}

const CardList: React.FC<CardListProps> = ({ data,  fetchMoreData, CustomerCard, expenseCard, invoiceCard, payHistoryCard, inventoryCard}) => {
  const loader = useRef<HTMLDivElement | null>(null);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [hasMoreData, setHasMoreData] = useState(true);

  useEffect(() => {
    const observer = new IntersectionObserver(handleObserver, { threshold: 1 });
    if (loader.current) {
      observer.observe(loader.current);
    }

    return () => {
      observer.disconnect();
    };
  }, []);

  const handleObserver = (entities: any[]) => {
    const target = entities[0];
    if (target.isIntersecting && hasMoreData && !loading) 
    {    
      loadMoreData();
    }
  };

  const loadMoreData = async () => {
    try {
      setLoading(true);
      const newData = await fetchMoreData(); 
    } catch (error) {
      console.error('Error fetching more data:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {data.map((item: TableItem, index: number) => (
        <Card paymentHistoryCard={payHistoryCard} CustomerCard={CustomerCard} expenseCard={expenseCard} invoiceCard={invoiceCard} inventoryCard={inventoryCard} key={index} data={item} menu={<DotMenu data={item} CustomerCard={CustomerCard} expenseCard={expenseCard} invoiceCard={invoiceCard} inventoryCard={inventoryCard} />} index={index}  />
      ))}
      {loading && <div>Loading...</div>}
      {hasMoreData && <div className="mb-5" ref={loader}></div>}
      {!hasMoreData && <div>No more data available</div>}
      {hasMoreData && !loading && <FloatingActionButton onClick={() => loadMoreData()} />}
    </>
  );
};

export default CardList;

